/** @format */

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SwatchColorSanitizerService {
  private readonly SANITIZE_PATTERN = /[^\w]/gi;

  sanitize(colorName: string | null | undefined): string {
    if (!colorName || typeof colorName !== 'string') {
      return '';
    }
    return colorName.trim().replace(this.SANITIZE_PATTERN, '_');
  }

  sanitizeEncoded(colorName: string | null | undefined): string {
    if (!colorName || typeof colorName !== 'string') {
      return '';
    }
    try {
      const decoded = decodeURIComponent(colorName.trim());
      return this.sanitize(decoded);
    } catch {
      return this.sanitize(colorName);
    }
  }
}
